import { ProductGroupsList } from "./components";
import { Outlet } from "react-router";
import { useGetProductGroups } from "./service/product-groups-api";
import { SpinnerBlock } from "../../common/Spinner";
import { useSelector } from "react-redux";
import * as authSelectors from "../../../module/auth/authSelectors";

export const ProductGroupsPage = () => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const { data: productGroups, isLoading } = useGetProductGroups(
    organizationKeyName
  );

  if (isLoading) {
    return <SpinnerBlock />;
  }

  return (
    <>
      <ProductGroupsList productGroups={productGroups || []} />
      <Outlet />
    </>
  );
};
